import PasswordStrengthIndicator from './PasswordStrengthIndicator';

export default PasswordStrengthIndicator;
